import { Link } from 'react-router-dom';
import { BreadcrumbContainer } from './style';
import React from 'react';
import { Skeleton, Tooltip } from '@mantine/core';

const SlashIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7209 2.79086C12.0205 3.00486 12.0899 3.42123 11.8759 3.72084L5.20921 13.0542C4.9952 13.3538 4.57883 13.4232 4.27923 13.2092C3.97962 12.9952 3.91022 12.5788 4.12423 12.2792L10.7909 2.94585C11.0049 2.64624 11.4213 2.57685 11.7209 2.79086Z"
      fill="#495057"
    />
  </svg>
);

const ArrowBackIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.7556 4.4107C10.081 4.73614 10.081 5.26378 9.7556 5.58921L6.17819 9.16663H15.833C16.2932 9.16663 16.6663 9.53972 16.6663 9.99996C16.6663 10.4602 16.2932 10.8333 15.833 10.8333H6.17819L9.7556 14.4107C10.081 14.7361 10.081 15.2638 9.7556 15.5892C9.43016 15.9147 8.90252 15.9147 8.57708 15.5892L3.57709 10.5892C3.25165 10.2638 3.25165 9.73614 3.57709 9.4107L8.57708 4.4107C8.90252 4.08527 9.43016 4.08527 9.7556 4.4107Z"
      fill="#495057"
    />
  </svg>
);

interface BreadcrumbLink {
  name?: string;
  value?: string;
  onClick?: () => void;
  isCurrent?: boolean;
  style?: React.CSSProperties;
}

interface BreadcrumbProps {
  links?: BreadcrumbLink[];
  withBackButton?: boolean;
  prevLink?: string;
  onBack?: () => void;
  isLoading?: boolean;
}

export default function Breadcrumb({
  links = [],
  withBackButton,
  prevLink,
  onBack,
  isLoading = false
}: BreadcrumbProps) {
  const currentIdx = links.findIndex(l => l?.isCurrent);

  if (isLoading)
    return (
      <BreadcrumbContainer>
        {withBackButton &&
          (onBack ? (
            <button type="button" aria-label="Go back" onClick={onBack}>
              <ArrowBackIcon />
            </button>
          ) : prevLink ? (
            <Link to={prevLink} reloadDocument>
              <button type="button" aria-label="Go back">
                <ArrowBackIcon />
              </button>
            </Link>
          ) : null)}

        <ul>
          <li>
            <Skeleton w={50} h={16} />
            &nbsp; <SlashIcon />
          </li>
          <li>
            <Skeleton w={70} h={16} />
            &nbsp; <SlashIcon />
          </li>
          <li>
            <Skeleton w={60} h={16} />
          </li>
        </ul>
      </BreadcrumbContainer>
    );

  return (
    <BreadcrumbContainer>
      {withBackButton &&
        (onBack ? (
          <button type="button" aria-label="Go back" onClick={onBack}>
            <ArrowBackIcon />
          </button>
        ) : prevLink ? (
          <Link to={prevLink} reloadDocument>
            <button type="button" aria-label="Go back">
              <ArrowBackIcon />
            </button>
          </Link>
        ) : null)}

      <ul>
        {links.map((link, idx) => {
          const isFuture = currentIdx !== -1 && idx > currentIdx;
          const className = link.isCurrent ? 'current' : isFuture ? 'future' : undefined;
          return (
            <li key={link.value ?? link.name} className={className}>
              {link.value || link.onClick ? (
                <Link reloadDocument to={link.value!} onClick={link.onClick} style={link.style}>
                  {link.name}
                </Link>
              ) : (
                <Tooltip
                  label={link?.name}
                  maw="300"
                  multiline
                  // @ts-ignore - name is optional but length comparison matches original behavior
                  disabled={link?.name?.length <= 85}
                >
                  <span>{link.name}</span>
                </Tooltip>
              )}{' '}
              &nbsp; {idx !== links.length - 1 && <SlashIcon />}
            </li>
          );
        })}
      </ul>
    </BreadcrumbContainer>
  );
}
